<script setup></script>

<template>
  <Select
    class="custom-select"
    :option-label="option => option.label"
    :option-value="option => option.value"
    :option-disabled="option => option.disabled"
    :filter-placeholder="$t('common.search')"
    :filter="true"
    :fluid="true"
    v-bind="$attrs"
  >
    <template #option="slotProps">
      <div
        class="custom-select-option"
        :class="{ 'is-disabled': slotProps.option.disabled }"
        v-tooltip.right="slotProps.option.tooltip"
      >
        {{ slotProps.option.label }}
      </div>
    </template>
    <template v-for="(_, name) of $slots" :key="name" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </Select>
</template>

<style lang="scss">
  .custom-select {
    width: 100%;

    .p-select-label {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .custom-select-option.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
